/// <amd-module name="Repos/ChangesActions/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\changes-actions\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Cherry pick a specific commit or commits that are associated to a pull request into a new branch.
     * 
     * @param cherryPickToCreate - 
     * @param project - Project ID or project name
     * @param repositoryId - ID of the repository.
     */
    createCherryPick(cherryPickToCreate: Git.GitAsyncRefOperationParameters, project: string, repositoryId: string): Promise<Git.GitCherryPick>;
    /**
     * Retrieve information about a cherry pick operation by cherry pick Id.
     * 
     * @param project - Project ID or project name
     * @param cherryPickId - ID of the cherry pick.
     * @param repositoryId - ID of the repository.
     */
    getCherryPick(project: string, cherryPickId: number, repositoryId: string): Promise<Git.GitCherryPick>;
    /**
     * Starts the operation to create a new branch which reverts changes introduced by either a specific commit or commits that are associated to a pull request.
     * 
     * @param revertToCreate - 
     * @param project - Project ID or project name
     * @param repositoryId - ID of the repository.
     */
    createRevert(revertToCreate: Git.GitAsyncRefOperationParameters, project: string, repositoryId: string): Promise<Git.GitRevert>;
    /**
     * Retrieve information about a revert operation by revert Id.
     * 
     * @param project - Project ID or project name
     * @param revertId - ID of the revert operation.
     * @param repositoryId - ID of the repository.
     */
    getRevert(project: string, revertId: number, repositoryId: string): Promise<Git.GitRevert>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Cherry pick a specific commit or commits that are associated to a pull request into a new branch.
     * 
     * @param cherryPickToCreate - 
     * @param project - Project ID or project name
     * @param repositoryId - ID of the repository.
     */
    public async createCherryPick(
        cherryPickToCreate: Git.GitAsyncRefOperationParameters,
        project: string,
        repositoryId: string
        ): Promise<Git.GitCherryPick> {

        return this.beginRequest<Git.GitCherryPick>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/cherryPicks/{cherryPickId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: cherryPickToCreate
        });
    }

    /**
     * Retrieve information about a cherry pick operation by cherry pick Id.
     * 
     * @param project - Project ID or project name
     * @param cherryPickId - ID of the cherry pick.
     * @param repositoryId - ID of the repository.
     */
    public async getCherryPick(
        project: string,
        cherryPickId: number,
        repositoryId: string
        ): Promise<Git.GitCherryPick> {

        return this.beginRequest<Git.GitCherryPick>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/cherryPicks/{cherryPickId}",
            routeValues: {
                project: project,
                cherryPickId: cherryPickId,
                repositoryId: repositoryId
            }
        });
    }

    /**
     * Starts the operation to create a new branch which reverts changes introduced by either a specific commit or commits that are associated to a pull request.
     * 
     * @param revertToCreate - 
     * @param project - Project ID or project name
     * @param repositoryId - ID of the repository.
     */
    public async createRevert(
        revertToCreate: Git.GitAsyncRefOperationParameters,
        project: string,
        repositoryId: string
        ): Promise<Git.GitRevert> {

        return this.beginRequest<Git.GitRevert>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/reverts/{revertId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: revertToCreate
        });
    }

    /**
     * Retrieve information about a revert operation by revert Id.
     * 
     * @param project - Project ID or project name
     * @param revertId - ID of the revert operation.
     * @param repositoryId - ID of the repository.
     */
    public async getRevert(
        project: string,
        revertId: number,
        repositoryId: string
        ): Promise<Git.GitRevert> {

        return this.beginRequest<Git.GitRevert>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/reverts/{revertId}",
            routeValues: {
                project: project,
                revertId: revertId,
                repositoryId: repositoryId
            }
        });
    }

}

export const GitClientName = "Repos.ChangesActions.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
